import { render, staticRenderFns } from "./data-subject-chart-overlay.vue?vue&type=template&id=23c5eaf1&scoped=true"
import script from "./data-subject-chart-overlay.vue?vue&type=script&lang=js"
export * from "./data-subject-chart-overlay.vue?vue&type=script&lang=js"
import style0 from "./data-subject-chart-overlay.vue?vue&type=style&index=0&id=23c5eaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5eaf1",
  null
  
)

export default component.exports